import VideoAspectRatio from './video-aspect-ratio';
import ChromeMobileReloadPlayer from './chrome-mobile-reload-player';
import OverrideVideoPoster from './override-video-poster';
import SafariIosAutoplayDrm from './safari-ios-autoplay-drm';
import VP9Reloader from './vp9-reloader';
import { PlayerEnvironment } from "../player_environment";

export default class Hotfix {
  constructor(tech, data) {
    this._tech = tech;
    this._data = data;
    this._videoAspectRatio = new VideoAspectRatio(tech);
    this._chromeMobileReloadPlayer = new ChromeMobileReloadPlayer({ tech, data });
    this._overrideVideoPoster = new OverrideVideoPoster(tech);
    this._safariIosAutoplayDrm = new SafariIosAutoplayDrm({ tech });
    this._vp9Reloader = new VP9Reloader({ tech });
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  init() {
    this.bindChromeMobileReloadPlayer();
    this.bindOverrideVideoPoster();
    this.bindSafariIosAutoplayDrm();
    this.bindVP9Reloader();
    this.forceResizePlayerForSpotxAd();
  }

  bindVideoAspectRatio() {
    this._videoAspectRatio.init(this.tech());
  }

  bindChromeMobileReloadPlayer() {
    if (PlayerEnvironment.browserVersion().startsWith('68') && PlayerEnvironment.browserName() == 'Chrome Mobile') {
      this._chromeMobileReloadPlayer.init(this.tech());
    }
  }

  bindOverrideVideoPoster() {
    if (window.playback_feature_toggle && window.playback_feature_toggle.indexOf('override_video_poster_for_instagram') != -1 ) {
      this._overrideVideoPoster.init(this.tech());
    }
  }

  bindSafariIosAutoplayDrm() {
    if (PlayerEnvironment.browserName() == 'Mobile Safari' && this.data().drmEnabled()) {
      this._safariIosAutoplayDrm.init();
    }
  }

  bindVP9Reloader() {
    if (VP9Reloader.shouldInit({ data: this.data() })) {
      this._vp9Reloader.init();
    }
  }

  forceResizePlayerForSpotxAd() {
    this.tech().on('adstarted', (e) => {
      if (e.adEvent.getAd().getAdSystem() === 'SpotXchange') {
        const container = this.tech().videoContainer();
        container.style.zoom = '1.00001';

        window.setTimeout(() => {
          container.style.zoom = '1';
        }, 1000);
      }
    });
  }
}
